import {
  ShopsApiErrorCodes,
  ShopsApiErrorResponse,
  ShopsApiException,
} from '@kotipizzagroup/kotipizza-shops-api-admin-client';

const shopsApiErrorMessages: Record<ShopsApiErrorCodes, string> = {
  [ShopsApiErrorCodes.UnknownError]: 'Odottamaton virhe. Yritä hetken päästä uudelleen.',
  [ShopsApiErrorCodes.ValidationError]: 'Virhe pyynnön validoinnissa. Otathan yhteyttä verkkokauppa-tiimiin.',
  [ShopsApiErrorCodes.Admin_UpdateOpeningHours_NotFound]:
    'Virhe aukioloaikojen päivittämisessä. Aukioloaikaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_UpdateOpeningHoursException_NotFound]:
    'Virhe aukioloaikojen päivittämisessä. Aukioloaikaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_CreateOpeningHoursException_NotFound]:
    'Virhe aukioloaikojen luomisessa. Aukioloaikaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_UpdateRestaurantStatus_TemporaryStatusNotAllowed]:
    'Virhe aukioloaikojen päivittämisessä. Valittu tila ei ole sallittu.',
  [ShopsApiErrorCodes.Admin_UpdateRestaurantStatus_PermanentStatusNotAllowed]:
    'Virhe aukioloaikojen päivittämisessä. Valittu tila ei ole sallittu.',
  [ShopsApiErrorCodes.Admin_UpdateRestaurantStatus_PermanentStatusNotFound]:
    'Virhe aukioloaikojen päivittämisessä. Valittua tilaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_GetRestaurantStatus_NotFound]:
    'Virhe ravintolan tilan hakemisessa. Ravintolaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_DeleteOpeningHoursException_NotFound]:
    'Virhe ravintolan aukioloaikojen poistamisessa. Aukioloaikaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_DeleteGlobalOpeningHoursException_NotFound]:
    'Virhe ravintolan aukioloaikojen poistamisessa. Aukioloaikaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_CreateLegalEntityError_AlreadyExists]:
    'Virhe yrityksen luomisessa. Sama Y-tunnus on jo olemassa tietokannassa.',
  [ShopsApiErrorCodes.Admin_CreateLegalEntityException]: 'Virhe yrityksen luomisessa.',
  [ShopsApiErrorCodes.Admin_GetLegalEntityException]: 'Virhe yrityksen hakemisessa.',
  [ShopsApiErrorCodes.Admin_GetLegalEntityError_NotFound]: 'Virhe yrityksen hakemisessa. Yritystä ei löytynyt.',
  [ShopsApiErrorCodes.Admin_UpdateLegalEntityError_NotFound]: 'Virhe yrityksen päivittämisessä. Yritystä ei löytynyt.',
  [ShopsApiErrorCodes.Admin_UpdateLegalEntityException]: 'Virhe yrityksen päivittämisessä.',
  [ShopsApiErrorCodes.Admin_LinkRestaurantToLegalEntityException]: 'Virhe yrityksen linkittämisessä.',
  [ShopsApiErrorCodes.Admin_SetShopBaseMenuIdShopNotFound]: 'Virhe menun asettamisessa. Ravintolaa ei löytynyt.',
  [ShopsApiErrorCodes.Admin_UpdatePublicHolidayPricingDate_AlreadyExists]: 'Virhe arkipyhän päivittämisessä.',
  [ShopsApiErrorCodes.Admin_UpdatePublicHolidayPricingDate_NotFound]: 'Virhe arkipyhän päivittämisessä.',
  [ShopsApiErrorCodes.Admin_DeletePublicHolidayPricingDate_NotFound]: 'Virhe arkipyhän poistamisessa.',
  [ShopsApiErrorCodes.Admin_UpdateShopAccessibilityInformationException]:
    'Virhe saavutettavuustietojen päivittämisessä.',
  [ShopsApiErrorCodes.GetShopAccessibilityInformation_NotFound]:
    'Virhe saavutettavuustietojen hakemisessa. Tietoja ei löytynyt.',
};

export function isShopsApiErrorResponse(obj: unknown): obj is ShopsApiErrorResponse {
  if (typeof obj !== 'object' || obj === null) {
    return false;
  }

  const maybe = obj as Partial<ShopsApiErrorResponse>;

  const isValidErrorCode = Object.values(ShopsApiErrorCodes).includes(maybe.errorCode as ShopsApiErrorCodes);
  const isValidErrorData = Array.isArray(maybe.errorData);
  const isValidErrorMessage =
    maybe.errorMessage === undefined || maybe.errorMessage === null || typeof maybe.errorMessage === 'string';

  return isValidErrorCode && isValidErrorData && isValidErrorMessage;
}

export const getShopsApiErrorMessage = (code?: ShopsApiErrorCodes | null): string => {
  if (code) {
    return shopsApiErrorMessages[code];
  }
  return shopsApiErrorMessages[ShopsApiErrorCodes.UnknownError];
};

export const getShopsApiError = (error: unknown): ShopsApiError => {
  if (error instanceof ShopsApiError) return error;

  if (ShopsApiException.isShopsApiException(error)) {
    error = error.response;
  }

  if (!isShopsApiErrorResponse(error)) {
    return new ShopsApiError(shopsApiErrorMessages[ShopsApiErrorCodes.UnknownError], ShopsApiErrorCodes.UnknownError);
  }

  return new ShopsApiError(shopsApiErrorMessages[error.errorCode], error.errorCode);
};

export class ShopsApiError extends Error {
  public errorCode: ShopsApiErrorCodes | null;
  constructor(errorMessage: string, errorCode: ShopsApiErrorCodes | null) {
    super(errorMessage);
    this.errorCode = errorCode;
  }
}
